export const generateTimeOptions = (
  interval: 5 | 15 | 30 | 60
): { value: string; label: string }[] => {
  const options: { value: string; label: string }[] = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += interval) {
      const time = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
      // Simple 12-hour format for display, value remains 24-hour
      const displayHour = hour % 12 === 0 ? 12 : hour % 12;
      const ampm = hour < 12 ? 'AM' : 'PM';
      const displayTime = `${String(displayHour).padStart(2, ' ')}:${String(minute).padStart(
        2,
        '0'
      )} ${ampm}`;
      options.push({ value: time, label: displayTime });
    }
  }
  return options;
};
